<template>
    <header class="itb-lazy-loading-bg" v-bind:class="{ 'itb-cart-header': !showElement }" v-lazy:background-image="!videoUrl && params && params.page_header_image
        ? '/uploads/' + params.page_header_image
        : null
        ">
        <video-background v-if="videoUrl" :src="videoUrl" poster="/images/articles/homepage-poster.webp">
        </video-background>

        <div v-if="params && params.page_header_bubble && showElement" id="itb-header-bubble"
            v-lazy:background-image="params.page_header_bubble"></div>
        <div v-if="appParams && appParams.staticTranslations" class="d-flex flex-column h-100"
            style="z-index: 2; position: relative">
            <nav class="navbar navbar-expand-lg navbar-dark p-0 fixed-top" id="itb-navbar">
                <div class="container" id="itb-header-wrapper">
                    <div class="itb-container-under-md" id="itb-navbar-header">
                        <a class="navbar-brand mr-auto" href="/">
                            <img src="/images/logo.png" :alt="appParams.staticTranslations[
                                'general.4soft_logo_link'
                            ]
                                " />
                        </a>

                        <ClientLogin v-if="!isLoggedIn && isResponsiveXs" :visible="messageDialog"
                            @close="messageDialog = false" @closeNavbar="closeNavbar"
                            @toggleStatic="showLoginStatic = false" />
                        <CartHover v-if="isLoggedIn && isResponsiveXs" :visible="showCart" :products="graphics"
                            :cartId="cartId" @close="showCart = false" @closeNavbar="closeNavbar" />
                        <AccountInformation v-if="isLoggedIn && isResponsiveXs" :visible="yourAccountDialog"
                            @close="yourAccountDialog = false" @closeNavbar="closeNavbar"
                            @toggleStatic="showAccountStatic = false" />

                        <div v-show="isResponsiveXs &&
                            (showAccountStatic || showLoginStatic)
                            " class="itb-overlay"></div>
                        <div @click="closeNavbar" v-show="isLoggedIn && (isResponsiveLg || isResponsiveXs)
                            " class="itb-header-icon mr-4">
                            <div class="position-relative pb-1 mt-1" @mouseover="openCart" @mouseleave="hideCart"
                                @click="goToCheckout">
                                <a class="nav-link itb-cart-link" href="javascript:void(0)">
                                    <img src="/images/shopping-basket-solid.png" alt="shopping-basket-solid"
                                        width="18px" />

                                    <span class="position-absolute badge badge-pill" id="itb-cart-counter">
                                        {{ cartCounter }}
                                    </span>
                                </a>
                                <CartHover v-if="isResponsiveLg && !isResponsiveXs" :visible="showCart"
                                    :products="graphics" :cartId="cartId" @close="showCart = false"
                                    @closeNavbar="closeNavbar" />
                            </div>
                        </div>
                        <div class="position-relative itb-header-icon mr-4" :class="{
                            'itb-icon-link-active': showAccountStatic,
                        }" v-if="
                            isLoggedIn && (isResponsiveLg || isResponsiveXs)
                        ">
                            <button class="itb-mdi-logo" @mouseover="openAccount" @mouseleave="hideAccount"
                                @click="toggleAccountStaticDisplay">
                                <span class="mdi mdi-account-cog" style="font-size: 27px; color: white"></span>
                            </button>
                            <AccountInformation v-if="isResponsiveLg && !isResponsiveXs" :visible="yourAccountDialog"
                                @close="yourAccountDialog = false" @closeNavbar="closeNavbar"
                                @toggleStatic="turnOffAccountStatic" />
                        </div>
                        <div class="position-relative mr-4" :class="{
                            'itb-icon-link-active': showLoginStatic,
                        }" v-if="
                            !isLoggedIn &&
                            (isResponsiveLg || isResponsiveXs)
                        ">
                            <button class="itb-mdi-logo" @mouseover="openLogin" @mouseleave="hideLogin"
                                @click="toggleLoginStaticDisplay">
                                <span class="mdi mdi-account-cog" style="font-size: 27px; color: white"></span>
                            </button>
                            <ClientLogin v-if="isResponsiveLg && !isResponsiveXs" :visible="messageDialog"
                                @close="messageDialog = false" @closeNavbar="closeNavbar"
                                @toggleStatic="turnOffLoginStatic" />
                        </div>

                        <div class="position-relative mr-4" v-if="
                            otherLanguages &&
                            otherLanguages.length &&
                            (isResponsiveLg || isResponsiveXs)
                        " @mouseover="openLanguageMenu" @mouseleave="closeLanguageMenu">
                            <button type="button" class="itb-mdi-logo itb-flag-button px-2" @click="toggleLanguageMenu">
                                <img class="itb-flag-icon" :src="'/images/flag_icons/' +
                                    currentLanguageModel.country_flag.toLowerCase() +
                                    '.svg'
                                    " />
                                <img width="7" src="/images/icons/4soft_icon_angle-down.svg" alt="down-menu"
                                    class="itb-icon itb-angle-down-icon" />
                            </button>
                            <LanguageMenu v-if="showLanguageMenu" :otherLanguages="otherLanguages"
                                @close="closeLanguageMenu" />
                        </div>

                        <button class="navbar-toggler collapsed" type="button" data-toggle="collapse"
                            data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false"
                            aria-label="Toggle navigation">
                            <span class="navbar-toggler-icon"></span>
                        </button>
                    </div>
                    <div class="itb-container-under-md ml-md-auto" id="itb-navbar-wrapper">
                        <div class="navbar-collapse collapse" id="navbarCollapse">
                            <ul class="navbar-nav ml-auto" id="itb-header-link-list">
                                <li class="nav-item" @click="closeNavbar">
                                    <router-link class="nav-link" :to="{ name: 'home' }">{{
                                        appParams.staticTranslations[
                                        "title.our_offer"
                                        ]
                                    }}</router-link>
                                </li>
                                <li class="nav-item" @click="closeNavbar">
                                    <router-link class="nav-link" :class="{
                                        'router-link-exact-active':
                                            subIsActive(
                                                '/2d-products/realizations'
                                            ),
                                    }" :to="{ name: 'products2D' }">{{
                                        appParams.staticTranslations[
                                        "title.products_2d"
                                        ]
                                    }}</router-link>
                                </li>
                                <li class="nav-item" @click="closeNavbar">
                                    <router-link class="nav-link" :class="{
                                        'router-link-exact-active':
                                            subIsActive(
                                                '/3d-products/realizations'
                                            ),
                                    }" :to="{ name: 'products3D' }">{{
                                        appParams.staticTranslations[
                                        "title.products_3d"
                                        ]
                                    }}</router-link>
                                </li>
                                <li class="nav-item" @click="closeNavbar">
                                    <router-link class="nav-link" :class="{
                                        'router-link-exact-active':
                                            subIsActive([
                                                '/water-fountains',
                                                '/mini-tunnels',
                                                '/built-in-tunnels',
                                                '/3d-playhouses',
                                                '/promotional-graphics',
                                                '/epdm-panelling',
                                                '/epdm-furniture',
                                            ]),
                                    }" :to="{ name: 'otherProducts' }">{{
                                        appParams.staticTranslations[
                                        "title.other_products"
                                        ]
                                    }}</router-link>
                                </li>
                                <li class="nav-item" @click="closeNavbar">
                                    <router-link class="nav-link" :to="{ name: 'ourService' }">{{
                                        appParams.staticTranslations[
                                        "title.our_service"
                                        ]
                                    }}</router-link>
                                </li>
                                <li class="nav-item" @click="closeNavbar">
                                    <router-link class="nav-link" :class="{
                                        'router-link-exact-active':
                                            subIsActive(
                                                '/choose-the-graphic'
                                            ) && !isLoggedIn,
                                        'itb-b2b-header-link': isLoggedIn,
                                        'itb-b2b-header-link-active':
                                            subIsActive(
                                                '/choose-the-graphic'
                                            ) && isLoggedIn,
                                    }" :to="{
                                        path: isLoggedIn
                                            ? '/choose-the-graphic/2D'
                                            : '/choose-the-graphic',
                                    }">{{
                                        isLoggedIn
                                            ? appParams.staticTranslations[
                                            "title.b2b"
                                            ]
                                            : appParams.staticTranslations[
                                            "title.graphics"
                                            ]
                                    }}</router-link>
                                </li>
                                <li class="nav-item" @click="closeNavbar">
                                    <router-link class="nav-link" :to="{ name: 'contact' }">{{
                                        appParams.staticTranslations[
                                        "title.contacts"
                                        ]
                                    }}</router-link>
                                </li>
                                <li class="nav-item itb-link-separator" @click="closeNavbar">
                                    <router-link class="nav-link" :to="{ name: 'download' }">
                                        {{
                                            appParams.staticTranslations[
                                            "title.download"
                                            ]
                                        }}
                                        <img src="/images/icons/4soft_icon_download.svg" :alt="appParams.staticTranslations[
                                            'general.download_link'
                                        ]
                                            " class="itb-icon itb-download-icon" />
                                    </router-link>
                                </li>
                                <li class="nav-item d-flex align-items-center" @click="closeNavbar">
                                    <a id="itb-instagram-link-youtube" class="nav-link itb-instagram-link-youtube"
                                        href="https://www.youtube.com/@michalkubin5692" target="_blank">
                                        <img src="/images/icons/youtube_logo.png" alt="youtube-link"
                                            class="itb-icon itb-instagram-icon" />
                                    </a>
                                    <a id="itb-instagram-link-instagram" class="nav-link itb-instagram-link-instagram"
                                        :href="appParams.general_instagram" target="_blank">
                                        <img src="/images/icons/instagram_logo.png" :alt="appParams.staticTranslations[
                                            'general.instagram_link'
                                        ]
                                            " class="itb-icon itb-instagram-icon" />
                                    </a>
                                </li>
                                <li class="nav-item itb-link-separator itb-link-login-box d-flex align-items-center"
                                    :class="{
                                        'itb-icon-link-active': showLoginStatic,
                                    }" v-if="
                                        !isLoggedIn &&
                                        !isResponsiveLg &&
                                        !isResponsiveXs
                                    " @mouseover="openLogin" @mouseleave="hideLogin" @click="toggleLoginStaticDisplay">
                                    <ClientLogin :visible="messageDialog" @close="messageDialog = false"
                                        @closeNavbar="closeNavbar" @toggleStatic="turnOffLoginStatic" />
                                    <span id="itb-login-tail-anchor" class="itb-login-text">
                                        {{
                                            appParams.staticTranslations[
                                            "general.login"
                                            ]
                                        }}
                                    </span>
                                </li>
                                <li class="nav-item itb-link-separator ml-0 pl-0" v-show="isLoggedIn &&
                                    !isResponsiveLg &&
                                    !isResponsiveXs
                                    " @mouseover="openCart" @mouseleave="hideCart">
                                    <div class="itb-header-icon" @click="
                                        closeNavbar();
                                    goToCheckout();
                                    ">
                                        <a class="nav-link itb-cart-link ml-0 pl-0" href="javascript:void(0)">
                                            <img src="/images/shopping-basket-solid.png" alt="shopping-basket-solid"
                                                width="18px" />

                                            <span class="position-absolute badge badge-pill" id="itb-cart-counter">
                                                {{ cartCounter }}
                                            </span>
                                        </a>
                                    </div>
                                    <CartHover :visible="showCart" :products="graphics" :cartId="cartId"
                                        @close="showCart = false" @closeNavbar="closeNavbar" />
                                </li>

                                <li class="nav-item itb-link-separator ml-0 pl-0" v-if="
                                    isLoggedIn &&
                                    !isResponsiveLg &&
                                    !isResponsiveXs
                                " @mouseover="openAccount" @mouseleave="hideAccount"
                                    @click="toggleAccountStaticDisplay">
                                    <div class="itb-header-icon" :class="{
                                        'itb-icon-link-active':
                                            showAccountStatic,
                                    }">
                                        <button class="itb-mdi-logo p-0">
                                            <span class="mdi mdi-account-cog" style="font-size: 27px"></span>
                                        </button>
                                    </div>
                                    <AccountInformation :visible="yourAccountDialog" @close="yourAccountDialog = false"
                                        @closeNavbar="closeNavbar" @toggleStatic="turnOffAccountStatic" />
                                </li>

                                <li class="nav-item itb-link-separator ml-0 pl-0" v-if="
                                    otherLanguages &&
                                    otherLanguages.length &&
                                    !isResponsiveLg &&
                                    !isResponsiveXs
                                " @mouseover="openLanguageMenu" @mouseleave="closeLanguageMenu">
                                    <button type="button" class="itb-mdi-logo itb-flag-button px-2"
                                        @click="toggleLanguageMenu">
                                        <img class="itb-flag-icon" :src="'/images/flag_icons/' +
                                            currentLanguageModel.country_flag.toLowerCase() +
                                            '.svg'
                                            " />
                                        <img width="10" src="/images/icons/4soft_icon_angle-down.svg" alt="down-menu"
                                            class="itb-icon itb-angle-down-icon" />
                                    </button>
                                    <LanguageMenu v-if="showLanguageMenu" :otherLanguages="otherLanguages"
                                        @close="closeLanguageMenu" />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
            <div class="text-center" id="itb-hero" v-if="showElement">
                <h1 :style="$route.path == '/other-products/epdm-panelling'
                    ? 'margin-top:160px;'
                    : ''
                    ">
                    {{ params.page_title }}
                </h1>
                <p class="itb-h1-subtitle">{{ params.page_subtitle }}</p>
                <button class="btn btn-primary itb-btn-double-icon ml-2 mr-2"
                    @click="scrollToElement('itb-page-content')" v-if="$route.name != 'home'">
                    <img src="/images/icons/4soft_icon_angle-down.svg" :alt="params.page_header_button_text"
                        class="itb-icon itb-angle-down-icon" />
                    {{ params.page_button_text }}
                    <img src="/images/icons/4soft_icon_angle-down.svg" :alt="params.headerButtonLabel"
                        class="itb-icon itb-angle-down-icon" />
                </button>
                <button v-if="params.page_button_element_2" class="btn btn-primary itb-btn-double-icon ml-2 mr-2"
                    @click="scrollToElement(params.page_button_element_2)">
                    <img src="/images/icons/4soft_icon_angle-down.svg" :alt="params.page_header_button_text"
                        class="itb-icon itb-angle-down-icon" />
                    {{ params.page_button_text_2 }}
                    <img src="/images/icons/4soft_icon_angle-down.svg" :alt="params.headerButtonLabel"
                        class="itb-icon itb-angle-down-icon" />
                </button>
                <button v-if="params.page_button_element_3" class="btn btn-primary itb-btn-double-icon ml-2 mr-2"
                    @click="scrollToElement(params.page_button_element_3)">
                    <img src="/images/icons/4soft_icon_angle-down.svg" :alt="params.page_header_button_text"
                        class="itb-icon itb-angle-down-icon" />
                    {{ params.page_button_text_3 }}
                    <img src="/images/icons/4soft_icon_angle-down.svg" :alt="params.headerButtonLabel"
                        class="itb-icon itb-angle-down-icon" />
                </button>
                <div class="itb-catalogue-link-wrapper d-flex justify-content-center align-items-center"
                    v-if="$route.name == 'home'">
                    <div class="d-flex justify-content-center align-items-center"
                        :class="{ 'flex-column': isResponsive600 }">
                        <div class="d-flex flex-column justify-content-center align-items-center">
                            <span id="itb-new-catalogue-text-1">{{
                                appParams.general_catalogue_title
                            }}</span><span id="itb-new-catalogue-text-2">{{
                                    appParams.general_catalogue_year
                                }}</span>
                        </div>
                        <img src="/images/catalogue-thumbnail.webp" :alt="params.headerButtonLabel"
                            class="itb-catalogue-thumbnail" v-if="!isResponsive600" />
                        <button type="button" @click="showCatalogue">
                            <span style="font-size: 1.4rem; font-weight: 900">{{
                                appParams.staticTranslations["general.browse"]
                            }}</span>
                        </button>
                    </div>
                    <img src="/images/catalogue-thumbnail.webp" :alt="params.headerButtonLabel"
                        class="itb-catalogue-thumbnail" v-if="isResponsive600" />
                </div>
            </div>
            <div class="d-flex align-items-center mx-auto mt-auto" id="itb-achievements" v-if="showElement" :class="params.page_is_on_references
                ? 'itb-long'
                : '' + params.achievementClass
                    ? params.achievementClass
                    : ''
                ">
                <div class="d-flex align-items-center mx-auto">
                    <span class="itb-number ml-0">{{
                        params.page_blue_bar_number_1
                    }}</span>
                    <span style="white-space: pre-line" v-html="params.page_blue_bar_text_1"></span>
                </div>

                <div class="d-flex align-items-center mx-auto">
                    <span class="itb-number">{{
                        params.page_blue_bar_number_2
                    }}</span>
                    <span style="white-space: pre-line" v-html="params.page_blue_bar_text_2"></span>
                </div>
                <div class="itb-reference d-flex ml-auto" v-if="params.page_is_on_references">
                    <div class="d-inline-block">
                        <button class="btn btn-link itb-prev">
                            <img src="/images/icons/4soft_icon_nav-left.svg" :alt="appParams.staticTranslations[
                                'general.prev_reference'
                            ]
                                " class="itb-icon" />
                        </button>
                        <button class="btn btn-link itb-next">
                            <img src="/images/icons/4soft_icon_nav-right.svg" :alt="appParams.staticTranslations[
                                'general.next_reference'
                            ]
                                " class="itb-icon" />
                        </button>
                    </div>
                    <div class="d-inline-block">
                        <span>Hřiště v Horní Dolní</span>
                        <br />
                        <a href="#">{{
                            appParams.staticTranslations[
                            "general.show_realization"
                            ]
                        }}</a>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { mapGetters } from "vuex";
import ClientLogin from "../components/ClientLogin";
import AccountInformation from "../components/AccountInformation";
import CartHover from "../components/CartHover";
import LanguageMenu from "../components/LanguageMenu";

export default {
    data() {
        return {
            path: null,
            messageDialog: false,
            yourAccountDialog: false,
            showCart: false,
            graphics: [],
            cartId: 0,
            isResponsiveLg: false,
            isResponsiveXs: false,
            isResponsive600: false,
            showLoginStatic: false,
            showAccountStatic: false,

            otherLanguages: [],
            currentLanguage: "",
            showLanguageMenu: false,
            applyOpeningMenuDelay: false,
            currentLanguageModel: { country_flag: "" },
        };
    },

    computed: {
        ...mapGetters({
            appParams: "getAppParams",
            params: "getPageParams",
            isLoggedIn: "getClientLogged",
            cartCounter: "getCartCounter",
            showCartCounter: "getShowCartCounter",
            profile: "getClientProfile",
        }),

        videoUrl() {
            if (this.$route.path == "/") {
                return "/uploads/homepage-en.mp4";
            }

            return false;
        },

        showElement() {
            if (
                this.$route.path == "/cookies-policy" ||
                this.$route.path == "/privacy-policy" ||
                this.$route.path == "/settings" ||
                this.$route.path == "/cart" ||
                this.$route.path.startsWith("/saved-carts") ||
                (this.$route.name == "graphicsByCategory" && this.isLoggedIn) ||
                (this.$route.name == "graphicDetail" && this.isLoggedIn) ||
                (this.$route.name == "graphicsByCategorySubcategory" &&
                    this.isLoggedIn)
            ) {
                return false;
            } else {
                return true;
            }
        },
    },

    watch: {
        $route: function (to, from) {
            this.createOtherLanguageLinks();
        },
    },

    created() {
        this.onResize();
        window.addEventListener("resize", this.onResize);

        this.getCurrentLanguage();
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },

    methods: {
        subIsActive(input) {
            const paths = Array.isArray(input) ? input : [input];
            return paths.some((path) => {
                return this.$route.path.includes(path);
            });
        },
        scrollToElement(elementId) {
            this.$parent.scrollToElement(elementId);
        },
        closeNavbar() {
            var element = document.getElementById("navbarCollapse");
            element.classList.remove("show");
        },

        openCart() {
            if (this.cartCounter > 0 && this.showCart == false) {
                this.showCart = true;
                this.getLastCart();
            }
        },

        hideCart() {
            this.showCart = false;
        },

        openLogin() {
            if (this.showLoginStatic == false) {
                this.messageDialog = true;
            }
        },

        hideLogin() {
            if (this.showLoginStatic == false) {
                this.messageDialog = false;
            }
        },
        toggleLoginStaticDisplay() {
            if (this.showLoginStatic == false) {
                this.closeNavbar();
            }
            this.showLoginStatic = !this.showLoginStatic;
            if (this.showLoginStatic == true && this.messageDialog == false) {
                this.messageDialog == true;
            } else if (
                this.showLoginStatic == true &&
                this.messageDialog == true
            ) {
                this.messageDialog == false;
            } else if (
                this.showLoginStatic == false &&
                this.messageDialog == true
            ) {
                this.messageDialog == false;
            } else if (
                this.showLoginStatic == false &&
                this.messageDialog == false
            ) {
                this.messageDialog == true;
            }
        },

        turnOffLoginStatic() {
            setTimeout(() => {
                this.showLoginStatic = false;
            }, 100);
        },

        openAccount() {
            if (this.showAccountStatic == false) {
                this.yourAccountDialog = true;
            }
        },

        hideAccount() {
            if (this.showAccountStatic == false) {
                this.yourAccountDialog = false;
            }
        },
        toggleAccountStaticDisplay() {
            if (this.showAccountStatic == false) {
                this.closeNavbar();
            }
            this.showAccountStatic = !this.showAccountStatic;
            if (
                this.showAccountStatic == true &&
                this.yourAccountDialog == false
            ) {
                this.yourAccountDialog == true;
            } else if (
                this.showAccountStatic == true &&
                this.yourAccountDialog == true
            ) {
                this.yourAccountDialog == false;
            } else if (
                this.showAccountStatic == false &&
                this.yourAccountDialog == true
            ) {
                this.yourAccountDialog == false;
            } else if (
                this.showAccountStatic == false &&
                this.yourAccountDialog == false
            ) {
                this.yourAccountDialog == true;
            }
        },
        turnOffAccountStatic() {
            setTimeout(() => {
                this.showAccountStatic = false;
            }, 100);
        },
        async getLastCart() {
            await axios
                .post("/getLastCart", this.profile)
                .then((response) => {
                    this.graphics = response.data;
                    if (response.data.length > 0) {
                        this.cartId = response.data[0].cart_id;
                    } else {
                        console.log("error");
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        onResize() {
            if (window.innerWidth >= 576 && window.innerWidth < 992) {
                this.isResponsiveLg = true;
            } else {
                this.isResponsiveLg = false;
            }

            if (window.innerWidth < 576) {
                this.isResponsiveXs = true;
            } else {
                this.isResponsiveXs = false;
            }

            if (window.innerWidth <= 600) {
                this.isResponsive600 = true;
            } else {
                this.isResponsive600 = false;
            }
        },
        showCatalogue() {
            this.$router.push({
                path: "/download",
                hash: "#itb-flipbook-title",
            });
        },

        goToCheckout() {
            if (this.$route.path != "/cart") {
                this.$router.push("/cart");
            }
            this.showCart = false;
            this.$emit("closeNavbar");
        },

        getCurrentLanguage() {
            axios
                .get("/getCurrentLanguage")
                .then((response) => {
                    this.$store.dispatch("setLanguage", response.data);
                    if (response.data) {
                        this.currentLanguage = response.data;
                        this.getOtherLanguages(response.data);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        getOtherLanguages(language) {
            axios
                .get("/getOtherLanguages/" + language)
                .then((response) => {
                    this.otherLanguages = response.data.otherLanguages;
                    this.currentLanguageModel =
                        response.data.currentLanguageModel;
                    this.createOtherLanguageLinks();
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        createOtherLanguageLinks() {
            this.otherLanguages.forEach((oLanguage) => {
                if (oLanguage.baseUrl) {
                    oLanguage.fullUrl =
                        oLanguage.baseUrl + this.$route.fullPath;
                }
            });
        },

        openLanguageMenu() {
            this.applyOpeningMenuDelay = true;
            this.showLanguageMenu = true;
            setTimeout(() => {
                this.applyOpeningMenuDelay = false;
            }, 200);
        },

        closeLanguageMenu() {
            this.showLanguageMenu = false;
        },

        toggleLanguageMenu() {
            if (!this.applyOpeningMenuDelay) {
                this.showLanguageMenu = !this.showLanguageMenu;
            }
        },
    },

    components: {
        ClientLogin,
        AccountInformation,
        CartHover,
        LanguageMenu,
    },
};
</script>
